import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "login-buttons" }

import { type OtButtonVariant } from '@1trading/design-system';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import useLogInOut from './useLogInOut';

type LoginButton = {
  id: string;
  text: string;
  variant: OtButtonVariant;
  className: string;
  onClick: () => Promise<void> | void;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginButtons',
  setup(__props) {

const { t } = useI18n({ useScope: 'global' });
const { login, signup } = useLogInOut();

const buttons = computed<Array<LoginButton>>(() => [
  {
    id: 'signup',
    text: t('modules.login.navBarSignupButtonText'),
    variant: 'primary',
    className: 'signup-button',
    onClick: signup,
  },
  {
    id: 'login',
    text: t('modules.login.navBarLoginButtonText'),
    variant: 'dark-outline',
    className: 'login-button',
    onClick: login,
  },
]);

return (_ctx: any,_cache: any) => {
  const _component_x_button = _resolveComponent("x-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(buttons.value, (btn) => {
      return (_openBlock(), _createBlock(_component_x_button, _mergeProps({
        id: btn.id,
        key: btn.id,
        class: ["login-buttons__button", btn.className],
        variant: btn.variant,
        text: btn.text,
        ref_for: true
      }, _ctx.$attrs, {
        onClick: btn.onClick
      }), null, 16, ["id", "variant", "class", "text", "onClick"]))
    }), 128))
  ]))
}
}

})